﻿import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { QRCodeCanvas as QRCode } from "qrcode.react";

import classes from "../maintainers.module.scss";

import { ReactComponent as PencilSvg } from "@/assets/images/desktop/editar.svg";
import { ReactComponent as RemoveSvg } from "@/assets/images/desktop/remove.svg";

import { hasPermission, validRoles } from "@/services/Utils";

import TableMultiple from "@/components/Table/Multiple/TableMultiple";

const UsersTableBody = ({ handleDelete, printQR, permissions, setTitleDetail, setItemsDetail, setShowDetail }) => {
	const navigate = useNavigate();
	const location = useLocation();

	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isAdmin = validRoles(userRoles, ["administrador"]);

	const { users } = useSelector((state) => state.maintainers_users);
	const { customer } = useSelector((state) => state.auth.user);

	const handleShow = (title, items) => {
		setTitleDetail(title);
		setItemsDetail(items);
		setShowDetail(true);
	};

	return (
		<tbody>
			{users &&
				users.map((item, i) => {
					return (
						<tr className={`${classes.table_tr}`} key={i}>
							<td className={`${classes.table_td} ${classes.first_td}`}>
								<div className={`${classes.table_div}  ${classes.first_div}`}>{i + 1}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.small_text}`}>{item.username}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.small_text}`}>{item.name}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center} ${classes.small_text}`}>{item.email}</div>
							</td>
							{!!customer.use_estates_parents && (
								<td className={`${classes.table_td}`}>
									<div className={`${classes.table_div} ${classes.multiple}`}>
										<TableMultiple
											textItems={item?.estates_parents?.map((item) => item.name).join(", ")}
											showFunction={handleShow}
											showTitle={"Campos"}
										/>
									</div>
								</td>
							)}
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.multiple}`}>
									<TableMultiple
										textItems={item?.estates?.map((item) => item.name).join(", ")}
										showFunction={handleShow}
										showTitle={"Bodegas"}
									/>
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.multiple}`}>
									<TableMultiple textItems={item?.roles?.map((item) => item.name).join(", ")} showFunction={handleShow} showTitle={"Roles"} />
								</div>
							</td>
							{isAdmin && !location.pathname.includes("configuracion") && (
								<td className={`${classes.table_td}`}>
									<div className={`${classes.table_div} ${classes.center} ${classes.small_text}`} style={{ justifyContent: "center" }}>
										{item.customer_name}
									</div>
								</td>
							)}
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center}`}>
									<QRCode
										value={`${item.id}`}
										size={35}
										style={{
											marginTop: "6px",
											cursor: "pointer",
										}}
										onClick={() => printQR(item)}
									/>
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.last_div}`}>
									{hasPermission("edit", permissions) && (
										<PencilSvg
											className={classes.icon}
											onClick={() =>
												location.pathname.includes("configuracion")
													? navigate("/configuracion/usuarios/editar/" + item.slug)
													: navigate("/mantenedores/usuarios/editar/" + item.slug)
											}
										/>
									)}

									{hasPermission("delete", permissions) && <RemoveSvg className={classes.icon} onClick={() => handleDelete(item)} />}
								</div>
							</td>
						</tr>
					);
				})}
		</tbody>
	);
};

export default UsersTableBody;
